import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import AnnualPlan from "../pages/annual-plan/page";
import Leadership from "../pages/leadership/page";
import Members from "../pages/members/page";
import Contact from "../pages/contact/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <Home />,
  },
  {
    path: "/annual-plan",
    element: <AnnualPlan />,
  },
  {
    path: "/leadership",
    element: <Leadership />,
  },
  {
    path: "/members",
    element: <Members />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
